import ButtonsComponent from './Buttons.component';

export * from './Buttons.component';
export default ButtonsComponent;